"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
import { Lock } from "lucide-react";
import { LoginDialog } from "./LoginDialog";

export function VerwaltungEntry() {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const [checking, setChecking] = useState(false);

  const onClick = async () => {
    if (checking) return;
    setChecking(true);
    try {
      // Same-origin: API läuft auf /api/* via nginx-Proxy.
      const res = await fetch("/api/v1/auth/me", { credentials: "include", cache: "no-store" });
      if (res.ok) {
        router.push("/admin");
        return;
      }
    } catch {
      // ignore — open modal
    } finally {
      setChecking(false);
    }
    setIsOpen(true);
  };

  return (
    <>
      <button
        type="button"
        aria-label="Verwaltung anmelden"
        title="Verwaltung"
        className="lp-icon-btn"
        onClick={onClick}
      >
        <Lock size={20} strokeWidth={2} aria-hidden="true" />
      </button>
      <LoginDialog open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
